<template>
  <div>
    <div class="d-flex justify-space-between">
      <h3>2 Square Tiles</h3>
      <FormSwitch v-model="isShow" switchColorClass="brand-500"></FormSwitch>
    </div>
    <div class="py-5">介紹區塊</div>
    <label class="pa-5 d-flex">
      <div class="w-180px"><h4>Title</h4></div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <textarea></textarea>
      </div>
    </label>

    <!-- items -->
    <PageCollapse v-for="(item, i) in itemList" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Product Name {{ i + 1 }}</h3>
      </template>
      <!-- <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template> -->
      <template v-slot:body>
        <!-- img uploader -->
        <div class="form-item d-flex py-5">
          <div class="w-180px">
            <h4 class="mb-10px">Image {{ i + 1 }}</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader></ImgUploader>
          </div>
        </div>

        <!-- Sub Title -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Sub TItle {{ i + 1 }}</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input type="text" v-model="item.subTitle" />
            </div>
          </div>
        </label>

        <!-- CTA Label -->
        <label class="px-5 d-flex">
          <h4 class="w-180px mt-5">CTA Label</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input type="text" v-model="item.ctaLabel" />
            </div>
          </div>
        </label>

        <!-- URL -->
        <label class="px-5 d-flex pb-6">
          <h4 class="w-180px mt-5">URL</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <v-icon class="prepend-icon">link</v-icon>
              <input type="text" class="pl-42px" v-model="item.url" />
            </div>
          </div>
        </label>
      </template>
    </PageCollapse>

    <!-- 添加 -->
    <!-- <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加</span>
      </button>
    </div> -->
  </div>
</template>

<script>
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    FormSwitch,
    PageCollapse,
    ImgUploader,
  },
  data: () => ({
    isShow: true,
    itemList: [
      {
        id: '001',
        image: '',
        subTitle: '',
        ctaLabel: 'Buy One Now',
        url: '',
      },
      {
        id: '002',
        image: '',
        subTitle: '',
        ctaLabel: 'Buy One Now 222',
        url: '',
      },
    ],
  }),
  // methods: {
  //   addItem() {
  //     const template = {
  //       id: Date.now(),
  //       title: `item ${Date.now()}`,
  //       description: '',
  //       visual: '',
  //     };
  //     this.itemList.push(template);
  //   },
  //   deleteItem(item) {
  //     const index = this.itemList.map((i) => i.id).indexOf(item.id);
  //     this.itemList.splice(index, 1);
  //   },
  //   downItem(item, i) {
  //     // if i is last, then item become the first index
  //     if (i === this.itemList.length - 1) {
  //       this.itemList.splice(i, 1);
  //       this.itemList.unshift(item);
  //       return;
  //     }
  //     // item become next index
  //     this.itemList.splice(i, 1);
  //     this.itemList.splice(i + 1, 0, item);
  //   },
  //   upItem(item, i) {
  //     // if i = 0, then item go to the last one
  //     if (i === 0) {
  //       this.itemList.splice(i, 1);
  //       this.itemList.push(item);
  //       return;
  //     }
  //     // item become previous index
  //     this.itemList.splice(i, 1);
  //     this.itemList.splice(i - 1, 0, item);
  //   },
  // },
};
</script>

<style></style>
